import { render } from "./BottleSticker.vue?vue&type=template&id=64b54365"
import script from "./BottleSticker.vue?vue&type=script&lang=js"
export * from "./BottleSticker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__